// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"HrVPSQMng6BAI06PIzBPE","moveToTopButton":"_3-phgGB7DPU0dEp755CHqn","controlButton":"_1RF1ZE7f-Feby-j1iu22wo","propertyInformationWrapper":"_3U1PIEIQGP9UI1HloyNyMW","propertyViews":"yeJ3Yl7lmGqJtloLl1P7o","phoneClicksCount":"_2pfTBJnlm4qrSRs0F3J1Y-","favouritesCount":"_3SAgcsm99PKyoo-dcIuBml","promotionsBlock":"_tlWHXYKDG62CXvRZmKbB","promotionsTitle":"uKmeLRQiWIXRT4wcthdpG","moveToTopButtonWrap":"LXuwV32kidclrlBfCV4af","moveToTopTooltip":"_1jBU5pfL3zhJdU8bwq0LI","inactiveOverlay":"r0t4Cm7V2fVD4MoF8L4fN","btnWr":"_1soBEbn2ir0hXM3Lx0xH7S"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMRegularManageCellMobile/OMRegularManageCellMobile.scss
// module id = 1675
// module chunks = 0